import React from 'react'

import Header from '../../templates/Header';
import Footer from '../../templates/Footer';
import SEO from '../../templates/SEO';

import Testimonials from '../../templates/Testimonials';

import course_1 from '../../../assets/images/stocks-2.jpg';

function Foundation() {
  return (
    <div>


<SEO title="Foundation Page"/>

<Header/>


<div class=" aboutarea__5">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                <div class="herobannerarea__content__wraper">


                    <div class="herobannerarea__title">
                        <div class="herobannerarea__small__title">
                            <span>BASIC PROGRAMS</span>
                        </div>
                        <div class="herobannerarea__title__heading__2 herobannerarea__title__heading__3">
                            <h2>The Foundation</h2>
                        </div>
                    </div>


                    <div class="herobannerarea__text herobannerarea__text__2">
                        <p>The stock market is a place where people buy and sell shares of companies. When you buy a share, you own a small part of that company. It's one of the best ways to grow your money over time.
                      <br />  Whether you're just starting or planning to become a trader, learning how the stock market works is the first step toward building wealth.
                        </p>
                    </div>
                    {/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">View Courses</a>
                        <a class="default__button hreobannerarea__button__3" href="#">Explore More</a>
                    </div> */}
                </div>


                <div class="aboutarea__list__2">
                    <p>The Foundation – Stock Market Trading & Investing</p>
                        <ul>
                            <li>
                               ✅ &nbsp; Stock Market
                            </li>

                            <li>
                            ✅ &nbsp; Trading & Investing
                            </li>

                            <li>
                            ✅ &nbsp; What Are Exchanges
                            </li>
                            <li>
                            ✅ &nbsp; How to Do Short Selling
                            </li>
                            <li>
                            ✅ &nbsp; Leverage
                            </li>
                            <li>
                            ✅ &nbsp; IPO Analysis
                            </li>
                            <li>
                            ✅ &nbsp; Risk Management
                            </li>
                            <li>
                            ✅ &nbsp; Market Participants
                            </li>
                            <li>
                            ✅ &nbsp; Market Segments
                            </li>
                            <li>
                            ✅ &nbsp; Order Types (Buy/Sell, Market/Limit)
                            </li>
                            <li>
                            ✅ &nbsp; Demat & Trading Account
                            </li>
                            <li>
                            ✅ &nbsp; Trading Psychology
                            </li>

                        </ul>
                    </div>
{/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">Buy Now</a>
                        <a class="default__button hreobannerarea__button__3" href="/contact">Contact Us</a>
                    </div> */}




            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">

                {/* <div class="herobanner__video registerarea__video">
                    <img loading="lazy" src="img/herobanner/herobanner__video.jpg" alt="Video Banner" />

                    <div class="video__pop__btn">
                        <a class="video-btn" href="https://www.youtube.com/watch?v=vHdclsdkp28"> <img loading="lazy" src="img/icon/video.png" alt=""/></a>
                    </div>
                </div> */}



<div class="gridarea__wraper">
                            <div class="gridarea__img">
                                <a href="course-details.html"><img loading="lazy"  src={course_1} alt="grid"/></a>
                                <div class="gridarea__small__button gridarea__small__button__1">
                                    <div class="grid__badge">Basics Programs</div>
                                </div>
                                <div class="gridarea__small__icon">
                                    <a href="#"><i class="icofont-heart-alt"></i></a>
                                </div>

                            </div>
                            <div class="gridarea__content">
                              
                                <div class="gridarea__heading">
                                    <h3><a href="">The Foundation</a></h3>
                                    <p>Essentials of stock trading</p>
                                </div>
                               
                                <div class="gridarea__price">
                                ₹9,999 + GST 
                                </div>
                                <div class="hreobannerarea__button__2">
                        <a class="default__button d-block text-center"  href="#">Buy Now</a>
                        
                    </div>
                 
                            </div>
                        </div>





                

            </div>

         
        </div>
    </div>
</div>


<Testimonials/>





<Footer/>

      
    </div>
  )
}

export default Foundation
